/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProbeCriteriaModel } from '../../models/probe-criteria-model';

export interface GetProbeCriteria$Params {
  patientID?: number;
}

export function GetProbeCriteria(http: HttpClient, rootUrl: string, params?: GetProbeCriteria$Params, context?: HttpContext): Observable<StrictHttpResponse<ProbeCriteriaModel>> {
  const rb = new RequestBuilder(rootUrl, GetProbeCriteria.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProbeCriteriaModel>;
    })
  );
}

GetProbeCriteria.PATH = '/api/Supervisor/GetProbeCriteria';
